import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';

// 4.2.7->Enable ngZone event coalescing to improve performance
platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .catch(err => console.error(err));
